import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Footer/sgds-footer";
import { register } from "../../utils/ce-registry";

register("sgds-footer", Component);

export default createComponent({
  react: React,
  tagName: "sgds-footer",
  elementClass: Component,
  events: {}
});
